import styled from "styled-components";

const ProgressBar = styled.ul`
  counter-reset: step -1;
  &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      background-color: ${props => props.appTopNavBgColor};
      z-index: -5
  }
  & li {
    list-style: none;
    display: inline-block;
    width: 30.33%;
    position: relative;
    text-align: center;
    background: none!important;
    padding: 0;
    color: ${props => props.appHomeTopNavIconColor};
    &:before {
      content: counter(step);
      counter-increment: step;
      width: 32px;
      height: 32px;
      line-height : 32px;
      border-radius: 100%;
      display: block;
      text-align: center;
      margin: 0 auto;
      color: ${props => props.appHomeTopNavIconColor};
      background-color: ${props => props.appHomeTopNavIconBackground};
    }

    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: ${props => props.appHomeTopNavIconBackground};
      top: 15px;
      left: -50%;
      z-index : -1;
    }
    &:first-child:after {
      content: none;
    }
    &.active {
      color: #2C2C2D;
    }
    &.active:before {
      color: #ffffff;
      background-color: ${props => props.backgroundColorTopBar};
    } 
    &.tick:before {
      content: '\\2713'
    }
    &.active:after {
      background-color: ${props => props.backgroundColorTopBar};
    }
    &:first-child:before {
      content: "X";
    }
  }
`;

export { ProgressBar };

ProgressBar.defaultProps = {
  backgroundColorTopBar: "rgb(44, 44, 45)"
}
